
import { loginApi } from "@/http/api_calls/LoginApi";
import { computed, defineComponent, ref } from "vue";
import { useCookieStore } from "@/logic/cookies";
import { store } from "@/store/LoginDataStore";
import { View } from "@/enums";

export default defineComponent({
  setup() {
    const { createCookiesFromStore } = useCookieStore();
    const state = store.getState();

    const customerId = ref("");
    const username = ref("");

    const selectedInfraUrl = ref();
    const disableProceedBtn = computed(() => state.infraUrls.length > 0 && !state.redirectUrl);

    const infraUrls = computed(() => state.infraUrls);

    function infraSelected(infraUrl: string) {
      store.setRedirectUrl(infraUrl);
    }

    const identifyUser = async () => {
      let redirectUrl = state.redirectUrl;
      if (!redirectUrl) {
        redirectUrl = await loginApi.getRedirectUrl(
          customerId.value,
          username.value
        );
      }

      if (redirectUrl === "/") {
        store.setUsername(username.value);
        store.setCustomerId(customerId.value);

        store.setView(View.PASSWORD);
      } else {
        createCookiesFromStore(username.value, customerId.value, "");
        window.location.replace(redirectUrl);
        store.setIsLoading(true);
      }
    };

    const checkIsInteger = (ev: KeyboardEvent) => {
      if(!ev.key.match(/\d/)) ev.preventDefault();
    };

    const trimHash = () => {
      username.value = username.value.replace(/#/g, "");
    };

    return {
      customerId,
      username,
      disableProceedBtn,
      infraUrls,
      selectedInfraUrl,
      infraSelected,
      identifyUser,
      checkIsInteger,
      trimHash,
    };
  },
});
